import { createElement } from "react";
import styles from "./Typography.module.css";

interface TypographyProps extends React.PropsWithChildren {
  component?: "div" | "span" | "p" | "h1";
  size?: number;
  weight?: number;
  color?: string;
  align?: string;
  whiteSpace?: string;
  style?: React.CSSProperties;
}

const Typography: React.FC<TypographyProps> = ({
  style,
  component = "span",
  size = "inherit",
  color = "inherit",
  weight,
  whiteSpace,
  align,
  children,
}) => {
  const fontSize =
    size === "inherit" ? size : `${1 + (1 / 8) * Number(size)}rem`;

  return createElement(
    component,
    {
      className: styles.container,
      style: {
        fontSize,
        whiteSpace,
        fontWeight: weight,
        textAlign: align,
        "--color": color,
        ...style,
      },
    },
    children
  );
};

export { Typography };
